/*
  ba-spare-parts-nav.js
  WHAT: Keeps the spare-parts category accordion to ONE open panel at a time.
  WHY:  Owner 2026-08-21: "when you click on a second category the first one
        should close to save space."
  WHEN: Added 2026-08-21.

  The markup already uses <details name="ba-parts-cat">, which is a native
  exclusive accordion in current Chrome, Safari and Firefox. This file exists
  only as the fallback for engines that ignore `name` — there it would otherwise
  behave as independent accordions and the sidebar could grow to ~40 rows, which
  is the exact problem the instruction was about.

  Harmless where `name` is supported: the browser has already closed the sibling
  by the time this runs, so the loop finds nothing to close.
*/
(function () {
  'use strict';

  var GROUP = 'ba-parts-cat';

  function closeSiblings(opened) {
    var all = document.querySelectorAll('details[name="' + GROUP + '"]');
    Array.prototype.forEach.call(all, function (d) {
      if (d !== opened && d.open) d.open = false;
    });
  }

  // `toggle` does not bubble, so bind per element rather than delegating.
  function bind(root) {
    var items = (root || document).querySelectorAll('details[name="' + GROUP + '"]');
    Array.prototype.forEach.call(items, function (d) {
      if (d.dataset.baExclusiveBound) return;
      d.dataset.baExclusiveBound = '1';
      d.addEventListener('toggle', function () {
        if (d.open) closeSiblings(d);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }

  // Re-bind when the theme editor re-renders the collection section.
  document.addEventListener('shopify:section:load', function (e) {
    bind(e.target || document);
  });
})();
